import { Box, styledComponent } from '@hermes/web-components'

export const AlertMessage = styledComponent(Box)(({ theme }) => ({
  padding: '40px 0',
  display: 'flex',
  justifyContent: 'center',
  '.MuiTypography-root': {
    maxWidth: '256px',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
    textAlign: 'center'
  },
  [theme.breakpoints.up('xs')]: {
    '.MuiTypography-root': {
      fontSize: '16px',
      lineHeight: '24px'
    }
  }
}))
